/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'TodoList'>;
const hooks = useModelQueries(schema, 'TodoList');

export const useAggregateTodoList: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountTodoList: Hooks['useCount'] = hooks.useCount;
export const useCreateTodoList: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyTodoList: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnTodoList: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteTodoList: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyTodoList: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsTodoList: Hooks['useExists'] = hooks.useExists;
export const useFindFirstTodoList: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyTodoList: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueTodoList: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByTodoList: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyTodoList: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateTodoList: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountTodoList: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstTodoList: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyTodoList: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueTodoList: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByTodoList: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyTodoList: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateTodoList: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyTodoList: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnTodoList: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertTodoList: Hooks['useUpsert'] = hooks.useUpsert;
